import {
  GroupBase as DefaultGroupBase,
  OptionProps,
  components,
} from 'react-select';
import { Checkbox } from 'src/components/atoms';
import { DefaultOption } from './DropdownOptions';
import {
  OptionValue,
  RightCheckboxContainer,
} from './RightCheckboxOption.styles';

export const RightCheckboxOption = <
  GroupBase extends DefaultGroupBase<DefaultOption> =
    DefaultGroupBase<DefaultOption>,
>(
  props: OptionProps<DefaultOption, boolean, GroupBase>,
) => {
  return (
    <components.Option {...props}>
      <RightCheckboxContainer>
        <OptionValue title={props.label}>{props.label}</OptionValue>
        <Checkbox
          checked={props.isSelected}
          onChange={() => {}}
          data-testid={`dropdown-option-${props.label}`}
        />
      </RightCheckboxContainer>
    </components.Option>
  );
};
